<script setup>
  import {computed} from "vue";

  import ComponentAlert from "@components/Alerts/Alert.vue";
  import {usePage} from "@inertiajs/vue3";

  defineOptions({
    name: "ComponentMessage",
  });

  const props = defineProps({
    displayMode: {
      type: String,
      default: "",
    },
  });

  const page = usePage();

  const filteredMessages = computed(() => {
    if (typeof page.props.messages !== "object") {
      return [];
    }

    return page.props.messages.filter((message) => {
      return message.display_mode === props.displayMode;
    });
  });
</script>

<template>
  <div v-if="filteredMessages.length > 0" class="print:hidden">
    <div v-for="(message, index) in filteredMessages" :key="index">
      <ComponentAlert :type="message.type || 'warning'" :test-id="getTestId(`message-${index}`)">
        <template v-if="message.title">
          <strong class="mr-2 inline-block" v-text="message.title" />
        </template>

        <!-- eslint-disable-next-line vue/no-v-html -- dashboard messages are authored in the backend Nova admin (DashboardMessage resource, plain Textarea field) and may contain HTML -->
        <span v-html="message.text || message" />
      </ComponentAlert>
    </div>
  </div>
</template>
